import { useState } from 'react';
import { DocumentHead } from '../components/DocumentHead';
import { Hero } from '../components/Hero';
import { TrustStrip } from '../components/TrustStrip';
import { Pathways } from '../components/Pathways';
import { WhyPegasus } from '../components/WhyPegasus';
import { HotTubs } from '../components/HotTubs';
import { BackyardLiving } from '../components/BackyardLiving';
import { ServiceCare } from '../components/ServiceCare';
import { SpecialsVisit } from '../components/SpecialsVisit';
import { SpecialsTextDialog } from '../components/SpecialsTextDialog';
export function Home() {
  const [textDialogOpen, setTextDialogOpen] = useState(false);
  return <>
      <DocumentHead data-id="element-303" data-mp="2dhqiutxig9hd" />
      <main data-id="element-304" data-mp="2di8bzhovm7l2">
        <Hero data-id="element-305" data-mp="2dhytef65v2pe" />
        <TrustStrip data-id="element-306" data-mp="2dii1z59x8eqr" />
        <Pathways data-id="element-307" data-mp="2dj1j4jrqyz3q" />
        <WhyPegasus data-id="element-308" data-mp="2dfdunz15t2vv" />
        <HotTubs data-id="element-309" data-mp="3kvtkrco2tnww" />
        <BackyardLiving data-id="element-310" data-mp="3ku8rdqdi0b0m" />
        <ServiceCare data-id="element-311" data-mp="3kuqzbk9iwdod" />
        <SpecialsVisit onOpenTextDialog={() => setTextDialogOpen(true)} data-id="element-312" data-mp="3kxmsywec8g70" />
      </main>
      <SpecialsTextDialog open={textDialogOpen} onClose={() => setTextDialogOpen(false)} data-id="element-313" data-mp="3oyyn9f85pplj" />
    </>;
}